<div class="modal-body content width-1400 height-1400">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getRessource('PDFSplitting')}} {{documentPDF.docPDF.dokName}}.pdf ({{vorgOrAuNr}})
    </span>
		<div class="content layout-auto-1">
			<div style="padding: 0 0.5rem;
			                           margin-bottom: 0.5rem;
                                 z-index: 20;
                                 box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);">
        <div class="grid-1-auto">
          <div class="spawn">
            <exg-checkbox [(ngModel)]="uiSaveInCase"
                          *ngIf="excSecurity.isFeatured('CASEEDIT')"
                          [tooltip]="uiSaveInCaseDisabled ? getRessource('No Tasks') : getRessource('SavePDFToTask')"
                          flow="right"
                          disabled="{{uiSaveInCaseDisabled}}"
                          caption="{{getRessource('Caption.SaveToCase')}}"
                          class="">
            </exg-checkbox>
            <exg-select #task name="TaskSelect" *ngIf="!uiSaveInCase && !uiSaveInCaseDisabled"
                        caption="{{getGlobal('Task')}}"
                        [(ngModel)]="uiSelectTaskIndex"
                        (ngModelChange)="setSelectedTask($event); task.closed=true"
                        [list]="uiTaskList"
                        listdisplay="vorgNr">
            </exg-select>
            <exg-select #t name="DokTypeSelect"
                        caption="{{enumSvc.getFieldCaption('Dokument','dok_enmIdent_DokTyp')}}"
                        [(ngModel)]="uiSelectDocumentTypeIndex"
                        (ngModelChange)="setDocumentType($event); t.closed=true"
                        [list]="enumSvc.getEnumerationList('DokTyp')"
                        listdisplay="enmText">
            </exg-select>
            <exg-input  [(ngModel)]="filename"
                        type="text"
                        [caption]="getRessource('Caption.FilenameInc', {nummerTyp: nummerTyp})">
            </exg-input>
          </div>
          <i class="search-action fa-regular fa-plus"
             [class.disabled]="answersLength === 0 || !isFilenameModified()"
             (click)="save()"
             style="margin: 4px 4px;">
          </i>
        </div>
			</div>


			<ng-container *ngIf="!documentPDF.isLoading && !init">
				<div class="content flex-container">
					<div class="flex-row">
						<ng-container *ngFor="let docElement of generatePageNumbers(documentPDF.docPDF.dokPages)">
							<div class="grid-auto-1">
								<div class="app-checkbox-multiSelection">
									<exg-checkbox [id]="documentPDF.docPDF.dokID + 'selection'"
									              [ngModel]="answers[docElement]"
									              (ngModelChange)="selection(docElement, $event)">
									</exg-checkbox>
								</div>
								<div class="md3-card-on-surface app-space" style="width: 300px"
								     style="padding: 4px 8px; margin: 4px 4px;">
									<div style="cursor: pointer" (click)="selection(docElement, !answers[docElement])">
										<img src="{{excRestService.computeUrl('ImageThumbnailBig',{dokID: documentPDF.docPDF.dokID, page: docElement - 1})}}"
										     alt="Seite_{{docElement}}"
										     class="list-avatar-placeholder"
										     style="text-align: center; width: 280px; height: 440px"/>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</ng-container>
			<div class="splash loading" *ngIf="documentPDF.isLoading">
				<div class="spinner">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="close()" class="md-btn">
				{{getGlobal('Close')}}
			</button>
		</div>
	</div>
</div>
